import { React, useContext } from 'react';
import './Sidebar.css';
import AuthContext from '../../../store/AuthContext';
import { useBuyerKnotTabs } from '../../../hooks/useBuyerKnotTabs';
import {
    isTruthyEnvFlag,
    SidebarHomeLink,
    SidebarTradeSimulator,
    SidebarBuyerSupplierAccount,
    SidebarInternalOpsNav,
    SidebarInvestorNav,
} from './Sidebar.helpers';

const Sidebar = (props) => {
    const ctx = useContext(AuthContext);
    const showAssignment = isTruthyEnvFlag(process.env.REACT_APP_SHOW_USER_ASSIGNMENT);
    const knotTabs = useBuyerKnotTabs(ctx.userData);
    return (
        <>
            <div
                className={
                    props.isBarExpanded ? 'custom-sidebar text-start bar-expanded' : 'custom-sidebar text-start'
                }>
                <SidebarHomeLink ctx={ctx} props={props} />
                <SidebarTradeSimulator ctx={ctx} props={props} knotTabs={knotTabs} />
                <SidebarBuyerSupplierAccount ctx={ctx} props={props} showAssignment={showAssignment} />
                <SidebarInternalOpsNav ctx={ctx} props={props} showAssignment={showAssignment} />
                <SidebarInvestorNav ctx={ctx} props={props} showAssignment={showAssignment} />
            </div>
            {props.isBarExpanded && <div className='bar-expanded-overlay' onClick={props.expandSidebar}></div>}
        </>
    );
};

export default Sidebar;
